module.exports = __webpack_public_path__ + "static/media/pic8.0c3b3bd8.jpg";